import { render } from "./CardHeader.vue?vue&type=template&id=513359bd&scoped=true"
import script from "./CardHeader.vue?vue&type=script&lang=js"
export * from "./CardHeader.vue?vue&type=script&lang=js"

import "./CardHeader.vue?vue&type=style&index=0&id=513359bd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513359bd"]])

export default __exports__